module.exports = __webpack_public_path__ + "static/media/02672C73-EB77-4CA4-83F2-EA5D124EE6D9.eb1e56bd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/make_over/02672C73-EB77-4CA4-83F2-EA5D124EE6D9.jpg
// module id = 272
// module chunks = 0